export default [
	//产品
	 {
		 path: 'product',
		 name: 'm_product_archive',
		 meta: {
		 },
		 props: route => route.params,
		 component: () => import('@/pages/basic/product_list')
	}
];